var SupportBasePresentation, SupportNowPresenterPresentation, SupportNowStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportNowStatusAndNotesPresentation = require('./now_messages');

SupportNowPresenterPresentation = (function(superClass) {
  extend(SupportNowPresenterPresentation, superClass);

  function SupportNowPresenterPresentation() {
    return SupportNowPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportNowPresenterPresentation.prototype.getLookupObject = function() {
    return SupportNowStatusAndNotesPresentation;
  };

  return SupportNowPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportNowPresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9ub3dfcHJlc2VudGVyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ByZXNlbnRlcnMvbm93X3ByZXNlbnRlci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSw4RkFBQTtFQUFBOzs7QUFBQSx1QkFBQSxHQUEwQixPQUFBLENBQVEsUUFBUjs7QUFDMUIsb0NBQUEsR0FBdUMsT0FBQSxDQUFRLGdCQUFSOztBQUVqQzs7Ozs7Ozs0Q0FDTCxlQUFBLEdBQWlCLFNBQUE7V0FDaEI7RUFEZ0I7Ozs7R0FENEI7O0FBSTlDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
